import UserVerifiedStep from './UserVerifiedStep';

export default UserVerifiedStep;
